import React from "react";
import { Link } from "react-router-dom";

export default function VerticalPlayerProducts({
  show,
  products = [],
  onShoppingSelect,
  disabled = false,
}: any) {
  return (
    <div
      className={`product_container ${disabled ? "product_container--disabled" : ""}`}
      style={{
        height: show ? "60px" : 0,
      }}
    >
      {products?.map((product: any) => (
        <div className="product_wrapper" key={product?._id}>
          <div className="product_info">
            <div className="left">
              <img
                src={product?.imageUrl}
                alt={`${product?.productId}-logo`}
              ></img>
            </div>
            <div className="right">
              <div className="flex flex-col">
                <h6>{product?.productName}</h6>
                <span>${product?.mrp}</span>
              </div>

              {product?.targetExperience?.toLowerCase() === "shopping" ? (
                <button
                  className="product-link"
                  onClick={() => {
                    if (disabled) return;
                    onShoppingSelect?.(product);
                  }}
                  type="button"
                  disabled={disabled}
                >
                  Add to Cart
                </button>
              ) : (
                disabled ? (
                  <span className="product-link product-link--disabled">
                    Buy
                  </span>
                ) : (
                  <Link
                    to={product?.shoppableLink}
                    target="_blank"
                    className="product-link"
                  >
                    Buy
                  </Link>
                )
              )}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
